import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {PermissionsService}                              from '@src/app/core/services/permissions.service';

@Directive({
    standalone: false,
    selector: '[appCan]'
})
export class CanDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef,
        private permissionsService: PermissionsService,
    ) {
    }

    @Input()
    set appCan(permission: string | string[]) {
        //Removed the below comment for testing
        // this.permissionsService.hasRole('super-admin') ||
        const permissions = Array.isArray(permission) ? permission : [permission];
        if (permissions.some(p => this.permissionsService.can(p))) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainerRef.clear();
        }
    }
}
